/* CT 2026-09-26 (v3) — Carruseles de la ficha (sections/ct-recomendaciones.liquid).
 * Los productos de metafields y de la colección principal ya vienen en Liquid (grupos p y c). Este script:
 * · arma la lista final p → r → c → f → t: f es la misma familia por nombre (templates/search.ct-reco.liquid), t el mismo tejido y
 *   composición (templates/collection.ct-reco.liquid); r son las recomendaciones de Shopify, que solo existen pidiéndolas; se piden UNA vez
 *   para las dos listas, solo si a alguna le faltan datos propios y solo al acercarse a la pantalla;
 * · sin repetidos entre listas: si la segunda sección es de compras reales, esas mandan y Similares no las repite; si no,
 *   Similares manda y la segunda no la repite. Nunca el mismo producto ni su otra presentación. Hasta data-ct-limite (10);
 * · flechas a los lados, "Ver más" en celular;
 * · GA4 (mismo camino que ct_inp): reco_view cuando la lista se ve y reco_click en cada tarjeta (no en sus cuadritos de
 *   color, que cambian la foto y no llevan a otra ficha), con lista (similares / comprados_juntos / tambien_interesa /
 *   moldes), origen, destino y posicion. Todo en eventos livianos (se mide el INP).
 */
(() => {
  if (window.ctRecoListo) return;
  window.ctRecoListo = true;
  const GA = 'G-3FXZLQ2NFP';
  const evento = (nombre, datos) => { try { if (typeof window.gtag === 'function') window.gtag('event', nombre, Object.assign({ send_to: GA }, datos)); } catch (e) { /* sin GA4 no pasa nada */ } };

  const flechas = (raiz) => {
    const pista = raiz.querySelector('.ct-reco__pista');
    const prev = raiz.querySelector('.ct-reco__flecha--prev');
    const next = raiz.querySelector('.ct-reco__flecha--next');
    if (!pista || !prev || !next) return () => {};
    let cola = false;
    const actualizar = () => {
      cola = false;
      const max = pista.scrollWidth - pista.clientWidth;
      const hay = max > 2 && getComputedStyle(pista).overflowX !== 'visible';
      raiz.classList.toggle('ct-reco--sin-flechas', !hay);
      prev.disabled = !hay || pista.scrollLeft <= 2;
      next.disabled = !hay || pista.scrollLeft >= max - 2;
    };
    const pedir = () => { if (!cola) { cola = true; requestAnimationFrame(actualizar); } };
    const mover = (dir) => pista.scrollBy({ left: dir * Math.max(pista.clientWidth * 0.9, 200), behavior: 'smooth' });
    prev.addEventListener('click', () => mover(-1));
    next.addEventListener('click', () => mover(1));
    pista.addEventListener('scroll', pedir, { passive: true });
    window.addEventListener('resize', pedir, { passive: true });
    actualizar();
    return pedir;
  };

  const medir = (raiz) => {
    raiz.addEventListener('click', (e) => {
      if (e.target.closest('.card__product-color-list')) return;
      const a = e.target.closest('a[href]');
      const item = a && a.closest('.ct-reco__item');
      if (!item || !raiz.contains(item)) return;
      evento('reco_click', { lista: raiz.dataset.ctLista || '', origen: raiz.dataset.ctOrigen || '', destino: item.dataset.ctPid || '', posicion: Number(item.dataset.ctPos) || 0, transport_type: 'beacon' });
    }, true);
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((ents) => {
      if (!ents.some((x) => x.isIntersecting)) return;
      io.disconnect();
      evento('reco_view', { lista: raiz.dataset.ctLista || '', origen: raiz.dataset.ctOrigen || '' });
    }, { threshold: 0.3 });
    io.observe(raiz.querySelector('.ct-reco__pista') || raiz);
  };

  // ---- Armado de las listas ----
  const sim = document.querySelector('.ct-reco--similares');
  const seg = document.querySelector('.ct-reco--comprados_juntos');
  const listas = [sim, seg].filter(Boolean);
  const pool = new Map(); // raiz → { p: [li], c: [li] } (nodos originales, se guardan para rearmar)
  let recs = []; // <li> de las recomendaciones de Shopify (se clonan por lista)
  let fam = []; // <li> de la misma familia por nombre (último respaldo; se clonan por lista)
  const refrescar = new Map();
  listas.forEach((r) => {
    const items = [...r.querySelectorAll('.ct-reco__item')];
    pool.set(r, { p: items.filter((i) => i.dataset.ctGrupo === 'p'), c: items.filter((i) => i.dataset.ctGrupo === 'c') });
  });
  const ids = (r) => (r ? [...r.querySelectorAll('.ct-reco__item')].map((i) => i.dataset.ctPid) : []);
  const armar = (raiz, excluir) => {
    if (!raiz) return;
    const pista = raiz.querySelector('.ct-reco__pista');
    const { p, c } = pool.get(raiz);
    const base = raiz.dataset.ctBase || '';
    const lim = Number(raiz.dataset.ctLimite) || 10;
    const real = raiz === seg && raiz.dataset.ctReal === 'true';
    // Bajo "Clientes que compraron…" solo compras reales: nada de recomendaciones ni colección.
    const candidatos = real ? p : [...p, ...recs.map((x) => x.cloneNode(true)), ...c, ...fam.map((x) => x.cloneNode(true))];
    const vistos = new Set(excluir);
    const final = [];
    for (const it of candidatos) {
      if (final.length >= lim) break;
      const pid = it.dataset.ctPid;
      if (!pid || vistos.has(pid) || pid === raiz.dataset.ctOrigen || (base && it.dataset.ctBase === base)) continue;
      vistos.add(pid);
      final.push(it);
    }
    final.forEach((it, i) => { it.dataset.ctPos = String(i + 1); });
    pista.replaceChildren(...final);
    raiz.classList.toggle('hidden', !final.length);
    const f = refrescar.get(raiz); if (f) f();
  };
  const armarTodo = () => {
    if (seg && seg.dataset.ctReal === 'true') { armar(seg, []); armar(sim, ids(seg)); }
    else { armar(sim, []); armar(seg, ids(sim)); }
  };

  // Recomendaciones de Shopify: una sola vez, al acercarse la primera lista que las necesita.
  const pedidos = listas.filter((r) => r.dataset.ctRecs);
  if (pedidos.length && 'IntersectionObserver' in window) {
    const url = pedidos[0].dataset.ctRecs;
    const io = new IntersectionObserver((ents) => {
      if (!ents.some((x) => x.isIntersecting)) return;
      io.disconnect();
      const leer = (u, sel) => fetch(u).then((r) => (r.ok ? r.text() : '')).then((t) => { const d = document.createElement('div'); d.innerHTML = t; return [...d.querySelectorAll(sel)]; }).catch(() => []);
      // Recomendaciones de Shopify y, en paralelo, la familia por nombre (solo se usa si con todo lo demás no llega a 10).
      const familia = pedidos[0].dataset.ctFamilia;
      const uFam = familia ? `${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}search?view=ct-reco&type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=hide&q=${encodeURIComponent(familia)}` : '';
      // Después de la familia, el mismo tejido y composición (filtros nativos de la tienda sobre el catálogo).
      const ds = pedidos[0].dataset, raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const uTej = ds.ctTejido ? `${raiz}collections/all?view=ct-reco&sort_by=best-selling&filter.p.m.woo.tejido-producto=${encodeURIComponent(ds.ctTejido)}${ds.ctComposicion ? `&filter.p.m.woo.composicion-producto=${encodeURIComponent(ds.ctComposicion)}` : ''}` : '';
      Promise.all([leer(url, '.ct-reco-respuesta .ct-reco__item'), uFam ? leer(uFam, '.ct-reco-familia .ct-reco__item') : [], uTej ? leer(uTej, '.ct-reco-familia .ct-reco__item') : []]).then(([r, f, t]) => {
        recs = r; fam = [...f, ...t];
        armarTodo();
      });
    }, { rootMargin: '0px 0px 600px 0px' });
    pedidos.forEach((r) => io.observe(r));
  }

  // Las dos listas y Moldes / Cursos: flechas, Ver más y medición.
  document.querySelectorAll('.ct-reco').forEach((raiz) => {
    const mas = raiz.querySelector('.ct-reco__ver-mas');
    if (mas) mas.addEventListener('click', () => { raiz.dataset.ctAbierto = '1'; mas.parentNode.remove(); });
    refrescar.set(raiz, flechas(raiz));
    medir(raiz);
  });
  armarTodo();
})();
